import { useNavigate, useLocation } from "react-router-dom";
import { Button, Alert, Spinner } from "react-bootstrap";
import { Colors } from "../utils/style";
import { useEffect, useState, useRef } from "react";
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import { axiosInstance } from "../App";

export default function AccountActivation() {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation('accountActivation');

  const [loading, setLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [isActivated, setIsActivated] = useState(false);

  const isFetched = useRef(false); // Prevent duplicate API calls

  useEffect(() => {
    if (isFetched.current) return; // Exit early if API has already been called

    isFetched.current = true; // Set flag to true after the first call

    const fetchActivationStatus = async () => {
      const params = new URLSearchParams(location.search);
      const token = params.get("token");

      if (!token) {
        setErrorMessage(t("MissingToken"));
        setLoading(false);
        return;
      }

      try {
        const response = await axiosInstance.get(process.env.REACT_APP_API_HOST_TEST + `activate-account?token=${token}`);
        if (response.status === 200) {
          setIsActivated(true);
          setErrorMessage(null);
        } else {
          setIsActivated(false);
          setErrorMessage(t("ActivationFailed"));
        }
      } catch (error) {
        setIsActivated(false);
        setErrorMessage(t("ActivationError"));
      } finally {
        setLoading(false);
      }
    };

    fetchActivationStatus();
  }, [location.search, t]);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        backgroundColor: Colors.DARK_GRAY,
        color: Colors.WHITE,
      }}
    >
      {loading ? (
        <Spinner animation="border" variant="light" />
      ) : (
        <>
          {isActivated ? (
            <Alert variant="success" style={{ width: "80%", textAlign: "center" }}>
              {t("AccountActivatedSuccessfully")}
            </Alert>
          ) : (
            <Alert variant="danger" style={{ width: "80%", textAlign: "center" }}>
              {errorMessage}
            </Alert>
          )}

          <Button
            variant="primary"
            onClick={() => navigate("/login")}
            style={{
              marginTop: "20px",
              padding: "10px 20px",
              fontSize: "16px",
            }}
          >
            {t("GoToLogin")}
          </Button>
        </>
      )}
    </div>
  );
}
